<template>
    <div>
        <div class=" container-md plr-0">
            <div class="container-bg p-4 pright-g">
                <h3>Betaalproviders</h3>
                <div class="row">

                    <div class="col-12">
                        <div class="flex-container flex-body pl-md-4 pr-md-4 mt-3 " v-for="(provider,index) in providers" :key="'payment_provider_' + index">
                            <div class="item " style="flex: 2 0 30%">
                                <p class="text-white"><b>{{ provider.name }}</b></p>
                            </div>
                            <div class="item text-white text-center">
                                <p>Status:
                                    <span v-if="provider.active" class="badge badge-success">Actief</span>
                                    <span v-else class="badge badge-danger">Inactief</span>
                                </p>
                            </div>
                            <div class="item text-white text-center">
                                <i 
                                    style="cursor:pointer" 
                                    data-toggle="modal" 
                                    data-target="#modalPaymentProvider" 
                                    class="fa fa-edit text-white" 
                                    @click="initModal(provider.id, index)"
                                ></i>

                                <i 
                                    style="cursor:pointer" 
                                    class="fa fa-trash ml-4 text-white" 
                                    @click="deleteProvider(provider.id, index)"
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--subscription modal start-->
        <div class="modal fade" id="modalPaymentProvider" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="!loading">

                            <div class="col-md-8 col-12 pl-md-5 pr-md-5">
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <h5 class="text-uppercase" v-if="provider.id">Bewerk Betaalprovider</h5>
                                        <h5 class="text-uppercase" v-else>Nieuwe Betaalprovider</h5>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="name">Naam:</label>
                                            <input type="text" class="form-control" id="name" v-model="provider.name">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-check form-check-inline ml-4">
                                            <label class="form-check-label mr-3 mt-2" for="active">Actief</label>
                                            <input class="form-check-input" type="checkbox" id="active"
                                                v-model="provider.active">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-12 mt-3">
                                        <button class="btn btn-dark text-white float-right" v-if="provider.id" @click="edit">Opslaan</button>
                                        <button class="btn btn-dark text-white float-right" v-else @click="create">Aanmaken</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-md-12 mb-3">
                                <h5 class="text-uppercase">Aan het laden</h5>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- subscription modal end-->

    </div>
</template>

<script>
    export default {
        name: "PaymentProvider",
        data(){
            return {
                provider : {
                    id: false,
                    name: '',
                    active: false,
                },
                providers : [],
                loading: true, 
                editIndex: null
            }
        },
        methods:{
            initModal(id, index = null) {
                if(id != 0) {
                    this.provider = this.providers.find(item => item.id == id)
                    this.editIndex = index
                }
            },

            async create(){
                let data = {
                    endpoint: 'api/v1/payment-providers',
                    details: {
                        'name': this.provider.name,
                        'active': this.provider.active
                    }
                }
                await this.$store.dispatch('post', data)
                    .then(data => {
                        this.providers.push(data.data.data)
                        this.reset()
                    })
                window.$('#modalPaymentProvider').modal('hide');
            },
            async edit() {
                let data = {
                    endpoint: 'api/v1/payment-providers/' + this.provider.id,
                    details: {
                        'name': this.provider.name,
                        'active': this.provider.active
                    }
                }
                await this.$store.dispatch('put', data)
                    .then((data)=>{
                        this.$set(this.providers, this.index, data.data.data)
                        this.reset()
                    })
                window.$('#modalPaymentProvider').modal('hide');
            },
            async deleteProvider(id, index) {
                 if(!window.confirm("Are you sure you want to delete this item?")) return false 

                await this.$store.dispatch('delete','api/v1/payment-providers/' + id);

                this.providers.splice(index, 1)
            },
            reset() {
                this.provider = {
                    id: false,
                    name: '',
                    active: false,
                }
            }
        },
        created(){
            this.loading = true;
            this.$store.dispatch('get','api/v1/payment-providers')
                .then((data)=>{
                    this.providers = data.data.data;
                    this.loading = false
                })
                .catch((error)=>{
                    console.log(error);
                    this.loading = false
                });

        },
    }
</script>

<style scoped>
    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;

        opacity: 1;
    }

    .flex-body {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
    }

    .item {
        flex: 1 1 11%;

        height: auto;
        margin: 4px;
        padding: 20px 0;
        width: auto;
    }

    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px;
            margin: 1.75rem auto;
            margin-top: 9rem;
        }

        .discount-modal {
            max-width: 600px !important;
            margin: 1.75rem auto;
        }
    }

    .form-control, .input-group-text {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 4px;
        opacity: 1;
        border: 1px #ced4da;;
    }

    .custom-scrollbar {
        overflow-y: scroll;
    }

    .custom-scrollbar::-webkit-scrollbar-track {
        background: #F4F5F7 0% 0% no-repeat padding-box;
        border-radius: 5px;
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 3px;
        background-color: #F5F5F5;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background: #4192D9 0% 0% no-repeat padding-box;
        border-radius: 5px;
    }

</style>
